module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/HotDay/Nagano_HotDay_MRI_RCP85_End.png";